import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Typography, makeStyles, GRAY } from '@applyboard/ui-components';
var useStyles = makeStyles({
  description: {
    margin: '24px 0',
    color: GRAY[10]
  }
});
var DialogContent = function DialogContent(_ref) {
  var title = _ref.title,
    description = _ref.description;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, title), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph",
    className: classes.description
  }, description));
};
export default DialogContent;